import { Card, CardContent } from '@epilot/journey-elements'
import { Fragment, type PropsWithChildren } from 'react'

import classes from './styles/BlockContent.module.scss'

type BlockContentProps = {
  showCard?: boolean
  isGroup?: boolean
  useNewDesign?: boolean
}

export function BlockContent({
  children,
  useNewDesign,
  isGroup,
  showCard
}: PropsWithChildren<BlockContentProps>) {
  if (showCard) {
    if (useNewDesign) {
      return <div className={classes.blockContentElevated}>{children}</div>
    }

    return (
      <Card className={classes.oldCard}>
        <CardContent className={classes.oldCardContent}>{children}</CardContent>
      </Card>
    )
  }

  // When the block is inside a group, we don't want to add any styling because the group already has its own styling
  if (!isGroup) {
    return <Fragment>{children}</Fragment>
  }

  if (useNewDesign) {
    return <div className={classes.blockContentDefault}>{children}</div>
  }

  return <div className={classes.oldBlockContentDefault}>{children}</div>
}
